import { render, staticRenderFns } from "./Mypass.vue?vue&type=template&id=1eded7b6&scoped=true&class=white&"
import script from "./Mypass.vue?vue&type=script&lang=ts&"
export * from "./Mypass.vue?vue&type=script&lang=ts&"
import style0 from "./Mypass.vue?vue&type=style&index=0&id=1eded7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eded7b6",
  null
  
)

export default component.exports